"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionEdit = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const spinner_1 = require("../../components/spinner/spinner");
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const page_state_1 = require("../../state/page.state");
const collection_meta_info_1 = require("./collection.meta.info/collection.meta.info");
const collection_view_style_1 = require("./collection.view.style");
const collection_view_subform_1 = require("./collection.view.subform");
const collection_view_title_1 = require("./collection.view.title");
class CollectionEdit {
    constructor(ctrl) {
        this.ctrl = ctrl;
        this.zoomRenderer = new core_shared_1.ZoomRenderer({
            zoomLevel: 2,
            size: {
                width: parseInt(collection_view_style_1.ZOOM_WIDTH),
                height: parseInt(collection_view_style_1.ZOOM_HEIGHT)
            },
            useCrosshair: true,
            crosshairCenterGap: 7.5
        });
    }
    view(toggleableElement = null) {
        if (!this.ctrl.isCollectionSelected) {
            return null;
        }
        const collection = this.ctrl.collection;
        if (collection == null) {
            if (!this.ctrl.isCollectionLoading) {
                return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.container + ' ' + collection_view_style_1.CSS.isMissing }, (0, index_1.Translate)(index_1.T.COLLECTION_MISSING));
            }
            // Extra non-div for IE11
            return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.container + ' ' + collection_view_style_1.CSS.isLoading }, (0, mithril_1.m)('span', spinner_1.Spinner.view()));
        }
        const containerElements = [
            collection_view_title_1.CollectionEditViewTitle.view(this.ctrl),
            this.ctrl.isMetadataShown ? collection_meta_info_1.CollectionMetaInfo.view(collection) : null,
            (this.ctrl.isPhotomeasure && this.ctrl.isZoomShown) ? this.viewZoom() : null,
            collection_view_subform_1.CollectionEditViewSubform.view(this.ctrl, collection)
        ];
        if (toggleableElement) {
            containerElements.push(toggleableElement);
        }
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.container }, containerElements);
    }
    viewZoom() {
        const zoomNode = this.zoomRenderer.view(page_state_1.CurrentState.CollectionEdit.currentDraw);
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.zoom }, zoomNode != null ? zoomNode : (0, index_1.Translate)(index_1.T.SELECT_MEASUREMENT));
    }
}
exports.CollectionEdit = CollectionEdit;
//# sourceMappingURL=collection.view.js.map